import "./GameCardMobile.style.css";

import { GameCardState } from "../../../utils/states/ConstructorPageStates/GameCardState";

import { IconTools16 } from "../../icons/IconTools/IconTools16";
import { IconGame16 } from "../../icons/IconGame/IconGame16";
import { IconDailyGame16 } from "../../icons/IconDailyGame16";
import { IconHeart16 } from "../../icons/IconHeart/IconHeart16";

interface GameCardProps {
  gameCard: GameCardState;
}

export const GameCardMobile = ({ gameCard }: GameCardProps) => {
  return (
    <div className="game-card-mobile">
      <div className="game-card-mobile__main">
        <div className="game-card-mobile__cover">
          <img
            className="game-card-mobile__cover-image"
            src={gameCard.image}
            alt={gameCard.name}
          />
          <span className="game-card-mobile__stats-container">
            <div className="game-card-mobile__stats">
              <div className="game-card-mobile__stat">
                <IconGame16 />
                {gameCard.playersAllCount}
              </div>
              <div className="game-card-mobile__stat">
                <IconDailyGame16 />
                {gameCard.playersTodayCount}
              </div>
              <div className="game-card-mobile__stat">
                <IconHeart16 />
                {gameCard.favoriteCount}
              </div>
            </div>
          </span>
        </div>
        <div className="game-card-mobile__info">
          <div className="game-card-mobile__title">{gameCard.name}</div>
          <div className="game-card-mobile__stat game-card-mobile__author">
            <IconTools16 color="#43CDFF" />
            {gameCard.author}
          </div>
        </div>
      </div>
      {gameCard.tags.length > 0 && (
        <div className="game-card-mobile__tags">
          {gameCard.tags.slice(0, 3).map((tag, index) => (
            <div className="game-card-mobile__tag" key={index}>
              #{tag}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
